import React from 'react';
const BONUSES = [{
  title: 'Su Felicidad Merece un Premio Natural',
  subtitle: 'Recetario natural de premios para tu compañero',
  image: 'https://cdn.magicpatterns.com/uploads/jRW7zy71eGq4JAyqv7sWKd/Bono_1.png',
  description: 'Aprende a preparar snacks y premios saludables que a tu perro le encantarán, sin conservantes ni químicos.'
}, {
  title: 'Primeros Auxilios',
  subtitle: 'Todo lo que tenes que saber al momento de una emergencia',
  image: 'https://cdn.magicpatterns.com/uploads/1nHJuCVkwgse9Tv2FySWqC/Bono_2.png',
  description: 'Una guía vital para saber exactamente cómo reaccionar ante accidentes, atragantamientos o emergencias médicas.'
}, {
  title: 'Cuando tu mascota habla',
  subtitle: '(y no la escuchamos)',
  image: 'https://cdn.magicpatterns.com/uploads/9rzBmQeKxyYcdPoLgH7jAB/Bono_3.png',
  description: 'Aprende a entender sus emociones, su comportamiento y cómo ayudarla a vivir mejor interpretando su lenguaje corporal.'
}, {
  title: 'El Plato Perfecto para tu Perro',
  subtitle: 'Según su edad, tamaño y necesidades',
  image: 'https://cdn.magicpatterns.com/uploads/mZtoPhWP45G9yFDUmWCJuT/Bono_4.png',
  description: 'Descubrí cómo armar el plato ideal para tu perro adaptado a su edad, tamaño y necesidades nutricionales específicas.'
}, {
  title: 'Hierbas que Sanan',
  subtitle: 'Restaurá el equilibrio digestivo de forma natural',
  image: 'https://cdn.magicpatterns.com/uploads/7q4fvsneYmaf9HUuFac8Aw/Bono_6.png',
  description: 'Conocé las hierbas naturales que ayudan a restaurar el equilibrio digestivo de tu perro y mejorar su bienestar general.'
}, {
  title: 'Calculadora de Alimentación Perfecta',
  subtitle: 'Según su peso, edad y nivel de actividad',
  image: 'https://cdn.magicpatterns.com/uploads/qmSYbM6LhxSKAE31tJ8b5E/Bono_5.png',
  description: 'Una herramienta práctica para calcular la ración diaria exacta que tu perro necesita. Fácil de usar con resultados en segundos.'
}];
export function BonusSection() {
  const scrollToPurchase = () => {
    document.getElementById('purchase-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 bg-emerald-50" data-id="element-2">
      <div className="max-w-5xl mx-auto px-4" data-id="element-3">
        <div className="text-center mb-12" data-id="element-4">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-[#000000] bg-[#FFFFFF]" data-id="element-5">
            Llevate estos{' '}
            <span className="font-[900] text-[#000000]" data-id="element-6">
              6 BONOS EXCLUSIVOS
            </span>
          </h2>
          <p className="text-xl font-medium inline-block px-4 py-1 rounded-full text-[#000000] bg-[#FEE245]" data-id="element-7">
            Totalmente GRATIS por el día de hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-8">
          {BONUSES.map((bonus, index) => <div key={index} className="bg-white rounded-2xl p-6 shadow-lg border border-emerald-100 flex flex-col items-center text-center transform transition hover:-translate-y-1" data-id="element-9">
              <div className="bg-pink-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-4 uppercase tracking-wide" data-id="element-10">
                Bono #{index + 1}
              </div>
              <img src={bonus.image} alt={bonus.title} className="w-full max-w-[200px] object-contain mb-6 cursor-pointer hover:scale-105 transition-transform drop-shadow-xl" onClick={scrollToPurchase} data-id="element-11" />
              <h3 className="text-xl font-bold text-stone-800 mb-2" data-id="element-12">
                {bonus.title}
              </h3>
              <p className="text-sm text-stone-500 mb-4 font-medium" data-id="element-13">
                {bonus.subtitle}
              </p>
              <p className="text-stone-600 text-sm" data-id="element-14">{bonus.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}